/**
 * File: IntlHelper.js
 * Project: Noname-Base-Frontend
 * File Created: Monday, 4th August 2025 12:19:14 pm
 * Author: Alexandru Ionut Dascalu (alexandru.dascalu@aerin.es)
 * Version: 1.0.0
 * -----
 * Last Modified: Monday, 4th August 2025 12:42:48 pm
 * Modified By: Alexandru Ionut Dascalu
 * -----
 * Copyright (c) 2023 - 2025 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

let intlInstance = null;

export const initIntl = (intl) => {
  intlInstance = intl;
};

export const translateMessage = (id, values = {}) => {
  if (!intlInstance) {
    console.warn(`IntlHelper | intl no inicializado: ${id}`);
    return id;
  }
  try {
    return intlInstance.formatMessage({ id }, values);
  } catch (e) {
    console.error(`IntlHelper | Error traduciendo: ${id}`, e);
    return id;
  }
};

export const getIntl = () => intlInstance;
